import { Box, Flex } from 'components/elements'
import { TableItemRow, TableTd } from 'theme/globalStyleCss'
import {
  ShimmerCss,
  ToggleCss,
  TitleCss,
  SubTitleCss,
  IconButtonCss,
} from './styles'

export const NetworkRuleShimmer = () => {
  return (
    <TableItemRow>
      <TableTd align={'center'}>
        <Flex direction={'column'}>
          <Box css={{ ...ShimmerCss, ...TitleCss, mb: '$space$2' }}></Box>
          <Box css={{ ...ShimmerCss, ...SubTitleCss }}></Box>
        </Flex>
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...IconButtonCss }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <Flex direction={'column'}>
          <Box css={{ ...ShimmerCss, ...TitleCss, mb: '$space$2' }}></Box>
          <Box css={{ ...ShimmerCss, ...SubTitleCss }}></Box>
        </Flex>
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...ToggleCss }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <Flex justify={'end'}>
          <Box css={{ ...ShimmerCss, ...IconButtonCss }}></Box>
        </Flex>
      </TableTd>
    </TableItemRow>
  )
}
